<div class="body">
  @for (rowData of ratingData(); track $index; let rowIndex = $index) {
    <div class="calculate">
      @for (column of headerCalculatorRatingRow.columns; track $index) {
        @if (column.key === 'targetRating') {
          <mat-form-field appearance="outline">
            <mat-label>Цель</mat-label>
            <input
              matInput
              type="number"
              min="0"
              max="5"
              [(ngModel)]="rowData.targetRating"
              (blur)="changeTargetRating(rowData, rowIndex)"
            >
          </mat-form-field>
        } @else {
          <div class="row-item">
            <div class="row-item-text">
              {{ getResult(rowIndex) }}
            </div>
          </div>
        }
      }
    </div>
    <div class="product">
      @for (column of headerProductRatingRow.columns; track $index) {
        <div
          class="row-item"
          [matTooltip]="rowData[column.key]?.toString() || ''"
        >
          <div class="row-item-text">
            {{ rowData[column.key] }}
          </div>
        </div>
      }
    </div>
    <div
      class="weekly"
      appScrollSync
      [sourceName]=`rating-weekly-body-${rowIndex}`
      [syncGroup]="'rating-weekly'"
    >
      @for (item of weeklyColumns; track $index) {
        <div
          class="row-item rating-grow"
          [class.rating-grow-up]="rowData.weeklyRatings.at(item)?.ratingGrowUp"
        >
          <div class="row-item-text">
            {{ rowData.weeklyRatings.at(item)?.markValue }}
          </div>
        </div>
      }
    </div>
  }
</div>
